import { atom } from 'jotai';

const initialOtherExpenseHistorySearchParams = {};

export const otherExpenseHistorySearchParamsAtom = atom<OtherExpenseHistorySearchParams>(
  initialOtherExpenseHistorySearchParams,
);
